import { mapState } from 'vuex';
import { Section, Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import { fontSize, lineHeight } from 'styled-system';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 0 20px 0 0;\n   color: #007582;\n   line-height: 40px;\n   font-size: 18px;\n   text-rendering: optimizeLegibility;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 12px;\n   margin-left: 4px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #6b5e51;\n   color: #007582;\n   font-size: 16px;\n   line-height: 19px;\n   font-weight: 300;\n   text-rendering: optimizeLegibility;\n   -webkit-font-smoothing: antialiased;\n   margin: 4px auto;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   color: #6b5e51;\n   color: #007582;\n   font-size: 13px;\n   line-height: 16px;\n   font-weight: 400;\n   text-rendering: optimizeLegibility;\n   -webkit-font-smoothing: antialiased;\n   margin: 4px auto;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 20px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #6b5e51;\n   color: #007582;\n   font-size: 18px;\n   line-height: 22px;\n   font-weight: 700;\n   text-rendering: optimizeLegibility;\n   -webkit-font-smoothing: antialiased;\n   white-space: nowrap;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   display: flex;\n   align-items: flex-start;\n   margin: 10px auto;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: column;\n   margin-top: 10px;\n   justify-content: center;\n   align-items: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   outline: 0;\n   margin: -10px 4px 0 4px;\n   color: #857363;\n   color: #007582;\n   flex: 1;\n   font-size: 16px;\n   font-weight: normal;\n   text-align: center;\n   text-rendering: optimizeLegibility;\n   -webkit-font-smoothing: antialiased;\n   text-align: center;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   border-top: 1px solid #d1c9c0;\n   border-top: 1px solid rgba(0, 0, 0, 0.4);\n   outline: 0;\n   padding: 0;\n   flex: 1;\n   margin: 0 10px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   margin-top: 20px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 0,\n\toutline: 0,\n\tmargin: auto;\n\tcolor: #fff;\n\twidth: 100%;\n\tfont-size: 24px;\n\tfont-weight: normal;\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\tbackground-color: ", ";\n\ttext-rendering: optimizeLegibility;\n\t-webkitFontSmoothing: antialiased;\n\ttext-align: center;\n\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   border: 0;\n   outline: 0;\n   margin: 6px;\n   display: flex;\n   flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   outline: 0;\n   margin: 0 20px 0 0;\n   width: 74%;\n   background-color: rgba(255, 255, 255, 0.9);\n   box-shadow: 1px 1px 3px 3px rgba(0, 0, 0, 0.3);\n   border: 1px solid rgba(0, 0, 0, 0.4);\n   position: relative;\n   max-width: 320px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n   ", "\n\n   color: #fff;\n   font-weight: 500;\n   margin: 20px;\n   text-rendering: optimizeLegibility;\n   text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.8);\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var H2 = styled("div", {
  fontSize: {
    default: function _default() {
      return [6, 6, 6, 7];
    },
    type: [Number, String, Object, Array]
  },
  lineHeight: {
    default: function _default() {
      return [4, 4, 5, 6];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject(), fontSize, lineHeight);
var ContactUsArea = styled("div", {})(_templateObject2());
var ContactUsInnerWrapper = styled.div(_templateObject3());
var ContactUsInnerTitleArea = styled("div", {})(_templateObject4(), function (props) {
  return props.theme.secondaryColor;
});
var CallUsLine = styled("div", {})(_templateObject5());
var LineBreak = styled("div", {})(_templateObject6());
var CallUsText = styled("div", {})(_templateObject7());
var CallUsBody = styled("div", {})(_templateObject8());
var Phone = styled("div", {})(_templateObject9());
var PhoneNumber = styled("div", {})(_templateObject10());
var PhoneIcon = styled("div", {})(_templateObject11());
var Hours = styled("div", {})(_templateObject12());
var DropDown = styled("div", {})(_templateObject13());
var DropDownText = styled("div", {})(_templateObject14());
var DropDownArrow = styled("img", {})(_templateObject15());
var ContactUsOffer = styled("div", {})(_templateObject16());

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-family: theme.fontFamily,\n\tcolor:  ", ";\n\tfont-size: 15px;\n\tline-height: 47px;\n\ttext-decoration: none;\n\twhite-space: nowrap;\n\ttext-shadow: 1px 1px 1px rgba(255,255,255, 1.4);\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n   font-family: inherit;\n   -webkit-font-smoothing: antialiased;\n   display: flex;\n   flex-direction: row;\n   vertical-align: middle;\n   text-align: center;\n   text-decoration: none;\n   appearance: none;\n\n   & li {\n      cursor: pointer;\n      list-style-type: none;\n      margin-right: 10px;\n      border-right: 2px solid #aaa;\n      border-left: 2px solid rgba(255, 255, 255, 1.8);\n      border-top: 2px solid rgba(255, 255, 255, 1.8);\n      height: 45px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0 10px 0 10px;\n      background: rgba(255, 255, 255, 0.8);\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n      box-shadow: 0px -2px 1px 1px rgba(0, 0, 0, 0.5);\n      margin-top: 3px;\n\n      &.router-link-exact-active {\n         background: #fff;\n         height: 50px;\n         margin-top: 0px;\n         color: ", ";\n         font-weight: bold;\n      }\n   }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n   position: absolute;\n   bottom: -1px;\n   left: 10px;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var TabContainer = styled.div(_templateObject$1());
var NavBar = styled("ul", {})(_templateObject2$1(), function (props) {
  return props.theme.primaryColor;
});
var NavItem = styled("a", {})(_templateObject3$1());
var TabLink = styled("a", {})(_templateObject4$1(), function (props) {
  return props.theme.primaryColor;
});

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  computed: _extends({}, mapState("viewport", ["breakpoint"]), {}, mapState("locale", ["locale"])),
  methods: {
    findMatchingBackground: function findMatchingBackground() {
      var _this = this;

      var match = this.copy.backgrounds.find(function (item) {
        return item.breakpoints.indexOf(_this.breakpoint) !== -1;
      });
      return match ? match.background : null;
    }
  },
  // mounted() {
  //    const engagementElement = document.getElementsByClassName(
  //       "engagement"
  //    )[0];
  //    const pathSegements = engagementElement.style.background.split('"');
  //    let img = document.createElement("img");
  //    img.onload = function() {
  //       setTimeout(() => {
  //          engagementElement.style.background = engagementElement.style.background.replace(
  //             "PRELOAD-",
  //             ""
  //          );
  //       }, 2000);
  //    };
  //    img.src = pathSegements[1].replace("PRELOAD-", "");
  // },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    // Find background style that best matches given breakpoint
    var background = this.findMatchingBackground(); // Add background image and inset drop shadow to section element

    var sectionStyle = {
      background: background,
      boxShadow: "inset 0 0 2px 2px rgba(0,0,0, .3)",
      borderBottom: "1px solid rgba(0,0,0, .7)"
    }; // Array of heights for each breakpoint

    var heights = ["353px", "353px", "465px", "500px"]; // Render navigation tabs

    var tabs = this.copy.tabs.map(function (tab) {
      // Modify the URL if this is the toggle locale link
      var url = _this2.locale === "es" ? tab.url + "/es" : "" + tab.url.replace("/es", "");
      return h("RouterLink", {
        "attrs": {
          "tag": "li",
          "to": url,
          "exact": true
        }
      }, [h(NavItem, {
        "attrs": {
          "href": url,
          "id": tab.id
        }
      }, [tab.title])]);
    });
    return h(Section, {
      "class": "engagement",
      "attrs": {
        "height": heights
      },
      "style": sectionStyle
    }, [h(Center, {
      "attrs": {
        "flexDirection": "row"
      }
    }, [h(Row, [h(Col, {
      "attrs": {
        "width": [12, 12, 7, 8, 8]
      }
    }, [h(H2, [this.copy.title])]), h(Col, {
      "attrs": {
        "width": [0, 0, 5, 4, 4],
        "display": ["none", "none", "flex"],
        "flexDirection": "row"
      }
    }, [h(ContactUsArea, [h(ContactUsInnerWrapper, [h(ContactUsInnerTitleArea, [this.copy.cta.button]), h(CallUsLine, [h(LineBreak), h(CallUsText, [this.copy.cta.callus]), h(LineBreak)]), h(CallUsBody, [h(Phone, [h(PhoneIcon, {
      "attrs": {
        "src": this.copy.cta.phoneIcon
      }
    }), h(PhoneNumber, [this.copy.cta.phone])]), h(Hours, [this.copy.cta.hours[0]]), h(Hours, [this.copy.cta.hours[1]]), h(DropDown, [h(DropDownText, [this.copy.cta.other]), h(DropDownArrow, {
      "attrs": {
        "src": this.copy.cta.arrowIcon
      }
    })])])])])])]), h(TabContainer, [h(NavBar, [tabs])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
